import React from "react"

import {
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import trans from "trans"

import { NumericInput } from "./fields";

const FrameForm = ({ formName, isDashed, shape }) => {
    return (
        <Grid cols={"1fr 1fr 1fr"} gap={'5px'}>
            <GridCell>{trans('margin')}</GridCell>
            <GridCell title={'x'}>
                <NumericInput
                    formName={formName}
                    fieldName={'margin_x'}
                    placeholder={'x'}
                    shapeIndex={shape.index}
                    id={'margin_x'}
                    min={0}
                    max={800}
                    step={1}
                    units={'px'}
                    value={Math.round(shape.margin_x)}
                />
            </GridCell>
            <GridCell title={'y'}>
                <NumericInput
                    formName={formName}
                    fieldName={'margin_y'}
                    placeholder={'y'}
                    shapeIndex={shape.index}
                    id={'margin_y'}
                    min={0}
                    max={800}
                    step={1}
                    units={'px'}
                    value={Math.round(shape.margin_y)}
                />
            </GridCell>

            {isDashed &&
                <React.Fragment>
                    <GridCell>{trans('dash_length')}</GridCell>

                    <GridCell title={trans("dash_length")}>
                        <NumericInput
                            formName={formName}
                            fieldName={'dash_length'}
                            placeholder={trans('dash_length')}
                            shapeIndex={shape.index}
                            id={'dash_length'}
                            min={0}
                            max={800}
                            step={1}
                            units={'px'}
                            value={Math.round(shape.dash_length)}
                            onlyPositive={true}
                        />
                    </GridCell>

                    <GridCell title={trans('dash_density')}>
                        <NumericInput
                            formName={formName}
                            fieldName={'dash_density'}
                            placeholder={trans('dash_density')}
                            shapeIndex={shape.index}
                            id={'dash_density'}
                            min={0}
                            max={800}
                            step={1}
                            units={'px'}
                            value={Math.round(shape.dash_density)}
                            onlyPositive={true}
                        />
                    </GridCell>
                </React.Fragment>
            }
        </Grid>
    )
}

export default FrameForm